<script>
    import {Dropdown, DropdownItem} from "flowbite-svelte";
    import {page} from "$app/stores";

    $: user_associate = $page.data.user_info?.associations.find(associate => associate.userId === $page.data.user_info.id);
    $: author = user_associate || {name: '@' + $page.data.user_info?.email?.split('@')[0]}
</script>

<div class="relative">
    <div class="text-neutral-400 whitespace-nowrap">{author.name}</div>
    <div class="flex gap-3 flex-1 text-xs align-items-center items-center text-neutral-600 dark:text-gray-300">
        <span>{user_associate?.customer?.name}</span>
        <svg class="w-3 h-3 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             fill="currentColor" viewBox="0 0 20 20">
            <path d="M18 7.5h-.423l-.452-1.09.3-.3a1.5 1.5 0 0 0 0-2.121L16.01 2.575a1.5 1.5 0 0 0-2.121 0l-.3.3-1.089-.452V2A1.5 1.5 0 0 0 11 .5H9A1.5 1.5 0 0 0 7.5 2v.423l-1.09.452-.3-.3a1.5 1.5 0 0 0-2.121 0L2.576 3.99a1.5 1.5 0 0 0 0 2.121l.3.3L2.423 7.5H2A1.5 1.5 0 0 0 .5 9v2A1.5 1.5 0 0 0 2 12.5h.423l.452 1.09-.3.3a1.5 1.5 0 0 0 0 2.121l1.415 1.413a1.5 1.5 0 0 0 2.121 0l.3-.3 1.09.452V18A1.5 1.5 0 0 0 9 19.5h2a1.5 1.5 0 0 0 1.5-1.5v-.423l1.09-.452.3.3a1.5 1.5 0 0 0 2.121 0l1.415-1.414a1.5 1.5 0 0 0 0-2.121l-.3-.3.452-1.09H18a1.5 1.5 0 0 0 1.5-1.5V9A1.5 1.5 0 0 0 18 7.5Zm-8 6a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"/>
        </svg>
    </div>
</div>

<Dropdown>
    <DropdownItem href="/settings">
        <i class="las la-cog"></i>
        Settings
    </DropdownItem>
    <DropdownItem href="/logout">
        <i class="las la-sign-out-alt"></i> Sign Out
    </DropdownItem>
</Dropdown>

<style>


</style>
